import * as React from "react";
import type { SVGProps } from "react";
const SvgCaretLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#74758C"
      fillRule="evenodd"
      d="M9.17.955c.44.439.44 1.151 0 1.59L3.217 8.5l5.955 5.954a1.125 1.125 0 0 1-1.591 1.592L.83 9.296a1.125 1.125 0 0 1 0-1.591L7.58.955c.439-.44 1.151-.44 1.59 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCaretLeft;
